import {z} from 'zod';
import type {TranslationFunction} from 'src/types/language-support.ts';


const normalizeText = (text: string): string => {
  return text
    .normalize('NFKC') // Convert full-width & compatibility forms
    .replace(/[‘’‛‹›]/g, '\'') // Smart apostrophes → regular
    .replace(/[“”„‟«»]/g, '"') // Smart quotes → regular
    .replace(/[–—‐‒⁃−]/g, '-') // Dashes → regular hyphen
    .replace(/…/g, '...') // Ellipsis → three dots
    .replace(/\s+/g, ' ') // Collapse multiple spaces
    .trim(); // Remove leading/trailing spaces
};

export const getReasonSchema = (t: TranslationFunction) =>
  z
    .string()
    .min(1, t('Reason_is_required', 'Reason is required'))
    .transform(normalizeText)
    .refine(
      (val: string) => val.length <= 150,
      t(
        'Reason_must_be_at_most_150_characters_long',
        'Reason must be at most 150 characters long',
      ),
    )
    .refine(
      (val: string) => /^[a-zA-Z0-9 ,.'"\-?!]*$/.test(val),
      t(
        'Only_words_numbers_and_basic_punctuation_allowed',
        'Only words, numbers and basic punctuation allowed',
      ),
    );
